const data = [
  { id: 'Justiça Estadual', name: 'Justiça Estadual' },
  { id: 'Justiça Federal', name: 'Justiça Federal' },
  { id: 'Justiça do Trabalho', name: 'Justiça do Trabalho' },
  { id: 'Justiça Eleitoral', name: 'Justiça Eleitoral' },
  { id: 'Justiça Militar', name: 'Justiça Militar' },
  { id: 'Tribunal Superior', name: 'Tribunal Superior' },
]

export default [...data]
